<!-- <div nz-row nzJustify="end">
  <button nz-button (click)="onOpenUserInfo()">Modal</button>
</div> -->


<div class="popup-form"> 
<form nz-form [formGroup]="validateForm"  [nzLayout]="'vertical'">
  <nz-row nzGutter="12"> 
    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
      <nz-form-label nzRequired>Tỉnh Thành</nz-form-label>
      <nz-select style="width: 100%;" nzMode="tags" nzPlaceHolder="Tag Mode" [(ngModel)]="listOfTagOptions"  [ngModelOptions]="{standalone: true}">
        <nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label" [nzValue]="option.value"></nz-option>
      </nz-select>
      </nz-form-item>
    </nz-col>

    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Trường</nz-form-label>
        <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">

          <input placeholder="try to type"  nz-input [(ngModel)]="inputValue" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange($event)" [nzAutocomplete]="auto" />
          <nz-autocomplete [nzDataSource]="filteredOptions" #auto></nz-autocomplete>

          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Please input your password! </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col> 
  
  </nz-row>

 
 
  <nz-row nzGutter="12">

    <nz-col nzLg="12" nzMd="12" nzSm="24">

      <nz-form-item>
        <nz-form-label nzRequired>Chọn học sinh</nz-form-label>
        <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">
           <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
          <input type="text" nz-input placeholder="input search text" />
        </nz-input-group>
        <ng-template #suffixButton>
          <button nz-button nzType="primary" nzSize="large" nzSearch (click)="showPopup()"><i nz-icon nzType="team" nzTheme="outline"></i></button>
        </ng-template> 
          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Please input your username! </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col> 

    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Lớp Học</nz-form-label>
        <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">

          <input placeholder="try to type" nz-input [(ngModel)]="inputValue" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange($event)" [nzAutocomplete]="auto" />
          <nz-autocomplete [nzDataSource]="filteredOptions" #auto></nz-autocomplete>

          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Please input your username! </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col> 

  </nz-row>

  <nz-row nzGutter="12">
    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Họ tên cha</nz-form-label>
        <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">
          <input nz-input placeholder="async validate try to write JasonWood" />
          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Please input your username! </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Số điện thoại cha</nz-form-label>
        <nz-form-control nzHasFeedback [nzErrorTip]="passwordErrorTpl">
          <input nz-input type="password" [placeholder]="'demo.confirm-password' | translate" />
          <ng-template #passwordErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> {{ 'demo.validate.password-confirm' | translate }} </ng-container>
            <ng-container *ngIf="control.hasError('confirm')"> {{ 'demo.validate.password-inconsistent' | translate }} </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </nz-row>
  <nz-row nzGutter="12">
    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Họ tên mẹ</nz-form-label>
        <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">
          <input nz-input placeholder="async validate try to write JasonWood" />
          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Please input your username! </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Số điện thoại mẹ</nz-form-label>
        <nz-form-control nzHasFeedback [nzErrorTip]="passwordErrorTpl">
          <input nz-input type="password" [placeholder]="'demo.confirm-password' | translate" />
          <ng-template #passwordErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> {{ 'demo.validate.password-confirm' | translate }} </ng-container>
            <ng-container *ngIf="control.hasError('confirm')"> {{ 'demo.validate.password-inconsistent' | translate }} </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </nz-row>

  <nz-row nzGutter="12">
    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Địa chỉ</nz-form-label>
        <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">
          <input nz-input placeholder="async validate try to write JasonWood" />
          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Please input your username! </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Email</nz-form-label>
        <nz-form-control nzHasFeedback [nzErrorTip]="passwordErrorTpl">
          <input nz-input type="password" [placeholder]="'demo.confirm-password' | translate" />
          <ng-template #passwordErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> {{ 'demo.validate.password-confirm' | translate }} </ng-container>
            <ng-container *ngIf="control.hasError('confirm')"> {{ 'demo.validate.password-inconsistent' | translate }} </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </nz-row>

  <nz-row nzGutter="12">
    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Họ tên cha</nz-form-label>
        <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">
          <input nz-input placeholder="async validate try to write JasonWood" />
          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Please input your username! </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Số điện thoại cha</nz-form-label>
        <nz-form-control nzHasFeedback [nzErrorTip]="passwordErrorTpl">
          <input nz-input type="password" [placeholder]="'demo.confirm-password' | translate" />
          <ng-template #passwordErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> {{ 'demo.validate.password-confirm' | translate }} </ng-container>
            <ng-container *ngIf="control.hasError('confirm')"> {{ 'demo.validate.password-inconsistent' | translate }} </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </nz-row>

  <nz-row nzGutter="12">
    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Họ tên cha</nz-form-label>
        <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">
          <input nz-input placeholder="async validate try to write JasonWood" />
          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Please input your username! </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Số điện thoại cha</nz-form-label>
        <nz-form-control nzHasFeedback [nzErrorTip]="passwordErrorTpl">
          <input nz-input type="password" [placeholder]="'demo.confirm-password' | translate" />
          <ng-template #passwordErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> {{ 'demo.validate.password-confirm' | translate }} </ng-container>
            <ng-container *ngIf="control.hasError('confirm')"> {{ 'demo.validate.password-inconsistent' | translate }} </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </nz-row>

  <nz-row nzGutter="12">
    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Họ tên cha</nz-form-label>
        <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">
          <input nz-input placeholder="async validate try to write JasonWood" />
          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Please input your username! </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Số điện thoại cha</nz-form-label>
        <nz-form-control nzHasFeedback [nzErrorTip]="passwordErrorTpl">
          <input nz-input type="password" [placeholder]="'demo.confirm-password' | translate" />
          <ng-template #passwordErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> {{ 'demo.validate.password-confirm' | translate }} </ng-container>
            <ng-container *ngIf="control.hasError('confirm')"> {{ 'demo.validate.password-inconsistent' | translate }} </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </nz-row>

  <nz-row nzGutter="12">
    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Họ tên cha</nz-form-label>
        <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">
          <input nz-input placeholder="async validate try to write JasonWood" />
          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Please input your username! </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Số điện thoại cha</nz-form-label>
        <nz-form-control nzHasFeedback [nzErrorTip]="passwordErrorTpl">
          <input nz-input type="password" [placeholder]="'demo.confirm-password' | translate" />
          <ng-template #passwordErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> {{ 'demo.validate.password-confirm' | translate }} </ng-container>
            <ng-container *ngIf="control.hasError('confirm')"> {{ 'demo.validate.password-inconsistent' | translate }} </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </nz-row>

  <nz-row nzGutter="12">
    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Họ tên cha</nz-form-label>
        <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">
          <input nz-input placeholder="async validate try to write JasonWood" />
          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Please input your username! </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Số điện thoại cha</nz-form-label>
        <nz-form-control nzHasFeedback [nzErrorTip]="passwordErrorTpl">
          <input nz-input type="password" [placeholder]="'demo.confirm-password' | translate" />
          <ng-template #passwordErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> {{ 'demo.validate.password-confirm' | translate }} </ng-container>
            <ng-container *ngIf="control.hasError('confirm')"> {{ 'demo.validate.password-inconsistent' | translate }} </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </nz-row>

  <nz-divider></nz-divider>

  <div *nzModalFooter> 
    <button nz-button nzType="default" (click)="destroyModal()">Đóng</button>
    <button nz-button nzType="primary" (click)="destroyModal()">Lưu</button>
  </div>
</form>
</div>